import { useDispatch, useSelector } from 'hooks/utils';
import { setAnalysisFullscreen, SetAnalysisFullscreenAction } from 'store/data/analyses';
import { LocalOperationResult } from 'hooks/store/types';
import { ActionPayload } from 'store/types';

export function useFullscreenAnalysis(): LocalOperationResult<
	string,
	(payload: ActionPayload<SetAnalysisFullscreenAction>) => void
> {
	const dispatch = useDispatch();

	const data = useSelector(state => state.data.analyses.fullscreen);

	function handler(payload: ActionPayload<SetAnalysisFullscreenAction>) {
		dispatch(setAnalysisFullscreen(payload));
	}

	return [data, handler];
}
